import React from 'react';
import PropTypes from 'prop-types';

const PwdEyeButton = ({ type, settype }) => {
  return (
    <button
      type="button"
      onClick={() => settype(type === 'password' ? 'text' : 'password')}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 0.72 0.72"
        xmlns="http://www.w3.org/2000/svg"
      >
        {type === 'text' ? (
          <path d="M.658.348C.597.207.483.12.36.12S.123.207.062.348a.03.03 0 0 0 0 .024C.123.513.237.6.36.6S.597.513.658.372a.03.03 0 0 0 0-.024M.36.54C.265.54.175.471.123.36.175.249.265.18.36.18s.185.069.237.18C.545.471.455.54.36.54m0-.3a.12.12 0 1 0 .12.12.12.12 0 0 0-.12-.12m0 .18A.06.06 0 1 1 .42.36a.06.06 0 0 1-.06.06" fill='#555' />
        ) : (
          <path d="M.328.182.36.18c.095 0 .185.069.237.18L.57.409a.03.03 0 0 0-.005.017.03.03 0 0 0 .056.015L.657.372a.03.03 0 0 0 0-.024C.597.207.483.12.36.12L.318.124a.03.03 0 1 0 .01.06ZM.111.069a.03.03 0 0 0-.043.043l.093.093a.4.4 0 0 0-.099.144.03.03 0 0 0 0 .024C.123.513.237.6.36.6A.3.3 0 0 0 .511.554l.097.098a.03.03 0 0 0 .043 0 .03.03 0 0 0 0-.043Zm.191.276.073.073L.36.42A.06.06 0 0 1 .3.36L.302.344M.36.54C.265.54.175.471.123.36A.4.4 0 0 1 .204.246L.257.3A.12.12 0 0 0 .42.463L.468.51A.2.2 0 0 1 .36.54" fill='#555' />
        )}
      </svg>
    </button>
  );
};

PwdEyeButton.propTypes = {
  type: PropTypes.string,
  settype: PropTypes.func,
};

PwdEyeButton.defaultProps = {
  type: 'password',
  settype: () => {},
};

export default PwdEyeButton;
